// Thin wrapper around the GA4 gtag already loaded in index.html.
// Never pass personal information (names, emails, phone numbers typed by the
// visitor, message text, children's details) as event parameters.

export const trackEvent = (name, params = {}) => {
  if (typeof window === "undefined" || typeof window.gtag !== "function") return;
  window.gtag("event", name, params);
};

// One document-level listener for contact links anywhere on the site, so
// every tel:, mailto: and WhatsApp link is measured without per-link wiring.
// Only the link type and the page it was clicked on are recorded.
export const listenForContactClicks = () => {
  const handler = (event) => {
    const link = event.target.closest?.("a[href]");
    if (!link) return;
    // Share buttons send their own `share` event; they aren't contact actions.
    if (link.closest("[data-share]")) return;
    const href = link.getAttribute("href") || "";
    const page_path = window.location.pathname;

    if (href.startsWith("tel:")) trackEvent("click_to_call", { page_path });
    else if (href.startsWith("mailto:")) trackEvent("email_click", { page_path });
    else if (/^https:\/\/wa\.me\//i.test(href)) trackEvent("whatsapp_click", { page_path });
  };

  document.addEventListener("click", handler);
  return () => document.removeEventListener("click", handler);
};
